import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { SkillsMain } from "./Components/SkillsMain";
import { SkillsResult } from "./Components/SkillsResult";
import { useTranslation } from "react-i18next";
import { addStorageObject } from "../../app/state/storageObjectSlice/actions/actions";
import styles from "./styles.module.css";

interface Props {
  className?: string;
}

export const Skills = ({ className }: Props) => {
  const dispatch = useAppDispatch();
  const { selectedObject } = useStorageSelectors("skills");
  const { t } = useTranslation();

  const handleAddDialogObject = () => {
    dispatch(
      addStorageObject({
        name: t("skills.default_name"),
        service: "skills",
        objectType: "child",
      }),
    ).unwrap();
  };

  if (selectedObject?.value === null) {
    return (
      <NoObjectChosen
        message={t("skills.no_object_message")}
        folderName={selectedObject.friendly_name}
        onClick={handleAddDialogObject}
      />
    );
  }

  return (
    <div className={styles.layout}>
      <SkillsMain />
      <SkillsResult />
    </div>
  );
};
